import styled from 'styled-components'

export const JobPostsMainSection = styled.main`
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 2rem;
`
